import React from "react";
import {Route, Routes} from "react-router-dom";
import Company from "../pages/Company";
import Home from "../pages/Home";
import Manager from "../pages/Manager";
import SuggestionList from "../container/suggestion/SuggestionList";
import Suggestion from "../pages/Suggestion";
import Education from "../pages/Education";
import NotFound from "../pages/NotFound";
import BoardManager from "../pages/BoardManager";

// note 사용자 등급 1 - 최고 어드민(SuperAdmin),  2 - 협회 마스터(Master)
const SuperLevel = () => {
  return (
    <Routes>
      <Route path="Home/*" element={<Home />} />
      <Route path="/Company/*" element={<Company />} />
      <Route path="/Manager/*" element={<Manager />} />
      <Route path="Suggestion/*" element={<Suggestion />} />
      <Route path="/BoardManager/*" element={<BoardManager />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default SuperLevel;
